module.exports = {
    ACTIVE_CLASS_MONEY_MARKET_ID: 'AC001',
    ACTIVE_CLASS_FIXED_INCOME_ID: 'AC002',
    ACTIVE_CLASS_EQUITY_ID: 'AC003',
    ACTIVE_CLASS_REAL_ASSETS_ID: 'AC004',
    ABSOLUTE_POS: 'absolute',
    BUILD_CAPITAL_ID: 'answer3',
    CARD_ONE: 1,
    CARD_TWO: 2,
    CARD_THREE: 3,
    CARD_FOUR: 4,
    CARD_FIVE: 5,
    COMMISSION_CONDITION_PDF: '/assets/static/pdf/CondicionesCostos0.pdf',
    CAROUSEL_FOR_LESS_THAN_SEVEN_TAB: 6,
    CAROUSEL_FOR_MORE_THAN_SEVEN_TAB: 7,
    CAROUSEL_FOR_SINGLE_TAB: 1,
    CONTRIBUTION_ISBAN_PERIOD_DAILY: 101,
    CONTRIBUTION_ISBAN_PERIOD_WEEKLY: 107,
    CONTRIBUTION_ISBAN_PERIOD_MONTHLY: 201,
    CONTRIBUTION_ISBAN_PERIOD_YEARLY: 301,
    CONTRIBUTION_PERIOD_DAILY: 365,
    CONTRIBUTION_PERIOD_WEEKLY: 52,
    CONTRIBUTION_PERIOD_MONTHLY: 12,
    CONTRIBUTION_PERIOD_PUNCTUAL: 1,
    DISTRIBUTION_MODAL_OPTION_TOTAL: 'TOTAL',
    DISTRIBUTION: 'DISTRIBUTION',
    CONTRIBUTION_ISBAN_CODE_DAILY: '101',
    CONTRIBUTION_ISBAN_CODE_WEEKLY: '107',
    CONTRIBUTION_ISBAN_CODE_MONTHLY: '201',
    CONTRIBUTION_ISBAN_CODE_YEARLY: '301',
    CUSTOM_PLAN_BY_OBJECTIVE_TITLE_MAX_LENGTH: 50,
    GLOBAL_TRACKING_URL_PARA: '',
    GOAL_DISTRIBUTION_URL: '/myprofile/robo/goalDistribution',
    GOAL_TRACKING_URL: '/myprofile/robo/objectiveTracking',
    GO_BACK_URL: 'goBack',
    PORTFOLIO_TRACKING_URL: '/myprofile/robo/portfolioTracking',
    OBJECTIVE_TRACK_URL_PARA: 'OT',
    PORTFOLIO_TRACK_URL_PARA: 'PT',
    INVEST_CAPITAL_ID: 'answer1',
    PRESERVE_CAPITAL_ID: 'answer2',
    INCREASE_CAPITAL_ID: 'answer4',
    DATE_FORMAT: 'D MMM YYYY',
    DATE_FORMAT_DAY_MONTH: 'D MMM',
    DATE_FORMAT_TIME_HORIZON_CHECK: 'YYYY-MM-DD',
    DATE_FORMAT_YEAR: 'YYYY',
    DEPOSIT: 'DEPOSIT',
    EMPTY_ISIN: 'EMPTY_ISIN',
    EVOLUTION_MODAL_OPTION_TOTAL: '0',
    FIXED_POS: 'fixed',
    HARDWARE_1: 'HARDWARE_1',
    HARDWARE_2: 'HARDWARE_2',
    APPLESTORE: 'APPLESTORE',
    LANGUAGE_ES: 'es-ES',
    GOOGLEPLAY: 'GOOGLEPLAY',
    APPLE_STORE_LINK: 'www.apple.com',
    GOOGLE_STORE_LINK: 'www.google.com',
    GLOBAL_FOOTER_ELEMENT: 'footer',
    FEE: 'FEE',
    FULL_MONTH_DAYS: 31,
    FAQ_URL: '/myprofile/robo/faq',
    MONTHS: 'MONTHS',
    YEARS: 'YEARS',
    HIGH_CONSERVATIVE: 'Muy conservador',
    CONSERVATIVE: 'Conservador',
    MODERATED: 'Moderado',
    DYNAMIC: 'Dinámico',
    AGGRESSIVE: 'Agresivo',
    RA_LAST_MOVEMENTS_URL: '/myprofile/robo/lastMovements',
    MANAGEMENT_PLAN_URL: '/myprofile/robo/management',
    HIRE_PLAN_URL: '/myprofile/robo/hire/hireManagementPlan',
    HIRE_OBJECTIVE_PLAN_URL:
        '/myprofile/robo/hire/hireManagementPlan/objective',
    HIRE_GBI_URL: '/myprofile/robo/hire/hireManagementPlan/gbi',
    INCOMING_OUTGOING_MAX: 9999999.99,
    INCOME: 'ingresos',
    EXPENSES: 'gastos',
    DISABLED_PROBABILITY: 'DISABLED',
    HIGH_PROBABILITY: 'HIGH',
    MEDIUM_PROBABILITY: 'MEDIUM',
    MINIMUM_CONTRIBUTION_AMOUNT: 1,
    LOW_PROBABILITY: 'LOW',
    NONE_PROBABILITY: 'NONE',
    SAVE_SIMULATION: 'SIMULACIÓN',
    LAST_MOVEMENTS_TABLE_RECENT_ITEMS: 'recents',
    LIQUIDITY_SUBASSETCLASS_ID: 'SAC000',
    MYPROFILE_BROKER_EDIT_URL: '/myprofile/edit',
    MYPROFILE_BROKER_GENERAL_URL: '/myprofile/broker/general',
    MYPROFILE_BROKER_ROBO_URL: '/myprofile/broker/general/robo',
    MYPROFILE_ROBO_SETGOAL: '/myprofile/robo/setGoal',
    MAXIMUM_MANAGEMENT_PLAN_INVESTMENT_AMOUNT: 99999999.99,
    MINIMUM_FUND_AMOUNT: 500,
    MAXIMUM_OBJECTIVE_AMOUNT: 99999999.99,
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT: 9999999.99,
    MAXIMUM_PERIODIC_CONTRIBUTION: 5000,
    MiFID_DURATION_UNTIL_EXPIRED: 1,
    MIFID_FLIER:
        '/assets/static/pdf/Pie%20de%20Página/Folleto%20Informativo%20MiFID.pdf',
    MINIMUM_MANAGEMENT_PLAN_INVESTMENT_AMOUNT: 500.0,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT: 500,
    ORIGIN_COUNTRY_GERMANY: 'DE',
    MINIMUM_OBJECTIVE_AMOUNT: 500,
    MINIMUM_STRATEGY_BALANCE_REIMBURSEMENT: 510,
    MINIMUM_PERIODIC_CONTRIBUTION: 1,
    PRODUCTION_RA_ENVIRONMENT: 'PRODUCCION',
    PROC_RA_ACCORDION_DISTRIBUTION_CHEVRON: 'chevron',
    PROC_RA_ASSOCIATIVE_OBJECTIVE: 'robo-advisor/asociar-objetivo',
    PROC_RA_ASSOCIATIVE_OBJECTIVE_ASSOCIATE_BUTTON: 'asociar objetivo',
    PROC_RA_ASSOCIATIVE_OBJECTIVE_MODIFY_OBJECT_NAME: 'modificar nombre objeto',
    PROC_RA_CANCEL: 'cancelar',
    PROC_RA_CANCEL_CONTRIBUTIONS_CONFIRM_CANCELATION: 'confirmar cancelación',
    PROC_RA_CANCEL_SERVICE_WALLET: 'robo cartera ',
    PROC_RA_CONFIRM: 'confirmar',
    PROC_RA_CONTRACTS_COST_SERVICE_MODAL: 'modal costes del servicio',
    PROC_RA_CONTRACTS_FINAL_SELECTION: 'eleccion final ',
    PROC_RA_CONTRACTS_WITH_FOUNDS: 'con fondos',
    PROC_RA_CONTRACTS_WITH_MONEY: 'con dinero',
    PROC_RA_CLOSE: 'cerrar',
    PROC_RA_UNDERSTOOD: 'entendido',
    PROC_RA_VIEW: 'vista',
    PROC_RA_DISTRIBUTION_WIDGET_CARD: 'card patrimonio',
    PROC_RA_DISTRIBUTION_WIDGET_TEXT: '¿Cómo calculamos estos datos?',
    PROC_RA_DISTRIBUTION_WIDGET_TOTAL: 'patrimonio total',
    PROC_RA_FAQS: 'robo-advisor/faq',
    PROC_RA_FAQS_INTERACTION: 'interaccion en faqs robo',
    PROC_RA_LAST_MOVEMENTS: 'robo-advisor/ultimos-movimientos',
    PROC_RA_LAST_MOVEMENTS_FILTER: 'filtro movimientos',
    PROC_RA_LAST_MOVEMENTS_SHOW_MORE: 'ver mas movimientos',
    PROC_RA_LAST_MOVEMENTS_WALLET_INTERACTION: 'interaccion con carteras',
    PROC_RA_MANAGMENT_PLAN: 'robo-advisor/plan-gestion',
    PROC_RA_MANAGMENT_PLAN_ACCORDION_OBJECTIVES: 'chevron objetivos',
    PROC_RA_MANAGMENT_PLAN_CLEAN_STRATEGY: 'limpiar estrategia',
    PROC_RA_MANAGMENT_PLAN_LIQUIDITY_TOOLTIP: 'tooltip liquidez',
    PROC_RA_MANAGMENT_PLAN_MANAGMENT_CONTRACT: 'contrato gestión',
    PROC_RA_MANAGMENT_PLAN_MODIFY_OBJECTIVE_NAME: 'modificar nombre objetivo',
    PROC_RA_MODIFY_WALLET_NAME: 'modificar nombre cartera',
    PROC_RA_MANAGMENT_PLAN_NO_OBJECTIVE: 'sin objetivo',
    PROC_RA_MANAGMENT_PLAN_OPEN_CLOSE: 'open/close',
    PROC_RA_MANAGMENT_PLAN_OPEN_MODAL: 'abrir modal',
    PROC_RA_MANAGMENT_PLAN_RISK_INDEX: 'indices de riesgo',
    PROC_RA_MANAGMENT_PLAN_SAVE_STRATEGY: 'guardar estrategia',
    PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_BANNER: 'configurar estrategia banner',
    PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_FOOTER: 'configurar estrategia faldón',
    PROC_RA_MANAGMENT_PLAN_SIMULATOR_INTERACTION: 'interacción simulador',
    PROC_RA_MANAGMENT_PLAN_WALLET_DETAILS: 'detalle cartera',
    PROC_RA_GLOBAL_POSITION_CLOSE_SIMULATION: 'cerrar simulacion',
    PROC_RA_GLOBAL_POSITION_EDIT_SIMULATION: 'editar simulacion',
    PROC_RA_GLOBAL_POSITION_FAQS: 'FAQs',
    PROC_RA_GLOBAL_POSITION_MORE_INFO: 'mas informacion',
    PROC_RA_GLOBAL_POSITION_NEW_CONTRIBUTION: 'nueva aportacion',
    PROC_RA_GLOBAL_POSITION_NEW_OBJECTIVE: 'nuevo objetivo',
    PROC_RA_GLOBAL_POSITION_NEW_WALLET: 'nueva cartera',
    PROC_RA_GLOBAL_POSITION_OBJECTIVES_CARD: 'card objetivos',
    PROC_RA_GLOBAL_POSITION_OPTIONS_MENU: 'menu opciones',
    PROC_RA_GLOBAL_POSITION_ORDERS_AND_MOVEMENTS: 'ordenes y movimientos',
    PROC_RA_GLOBAL_POSITION_PATRIMONY_EVOLUTION: 'evolucion del patrimonio',
    PROC_RA_GLOBAL_POSITION_RESPONSIBLE_PROFITABILITY:
        'rentabilidad responsable',
    PROC_RA_GLOBAL_POSITION_RETURN_TEST: 'retomar test',
    PROC_RA_GLOBAL_POSITION_HAVE_CONTRACT: 'si',
    PROC_RA_GLOBAL_POSITION_HAVE_NO_CONTRACT: 'no',
    PROC_RA_GLOBAL_POSITION_SHOW_OBJECTIVE: 'ver objetivo',
    PROC_RA_GLOBAL_POSITION_SHOW_WALLET: 'ver cartera',
    PROC_RA_GLOBAL_POSITION_SUITABILITY_TEST: 'test idoneidad',
    PROC_RA_GLOBAL_POSITION_TOP_MENU: 'menu superior',
    PROC_RA_GLOBAL_POSITION_TOTAL_PATRIMONY: 'patrimonio total',
    PROC_RA_GLOBAL_POSITION_US_MANAGMENT: 'nosotros la gestion',
    PROC_RA_GLOBAL_POSITION_WALLETS_CARD: 'card carteras inversion',
    PROC_RA_GLOBAL_POSITION_DISTRIBUTION_MODAL: 'ver distribucion',
    PROC_RA_GLOBAL_POSITION_ADITIONAL_CONTRIBUTION: 'aportaciones',
    PROC_RA_GLOBAL_POSITION_NEW_ADITIONAL_CONTRIBUTION: 'nueva aportación',
    PROC_RA_GO_BACK: 'volver',
    PROC_RA_GO_TO_ORDERS_AND_MOVEMENTS: 'ir a ordenes y movimientos',
    PROC_RA_HELP_PATRIMONY_CALCULATION: 'ayuda cálculo Patrimonio',
    PROC_RA_HIRE: 'contratar',
    PROC_RA_MANAGE_CONTRIBUTIONS: 'gestionar aportaciones',
    PROC_RA_NEW_CONTRIBUTION: 'Nueva aportación',
    PROC_RA_OBJECTIVE_TRACKING: 'robo-advisor/objective-tracking',
    PROC_RA_OBJECTIVE_TRACKING_INTERACTION: 'interaccion objective tracking',
    PROC_RA_OBJECTIVE_TRACKING_EDIT_IMPORT_AMOUNT: 'editar importe objetivo',
    PROC_RA_OBJECTIVE_TRACKING_EVOLUTION_CHART_HELP: 'ayuda evolución gráfico',
    PROC_RA_OBJECTIVE_TRACKING_MONEY_MARKET_HELP: 'ayuda mercado inversión',
    PROC_RA_OBJECTIVE_TRACKING_DISTRIBUTION: 'distribución inversión',
    PROC_RA_OBJECTIVE_TRACKING_MODIFY_STRATEGY: 'Modificar estrategia',
    PROC_RA_OBJECTIVE_TRACKING_PARTIAL_REFUND: 'reembolso parcial',
    PROC_RA_OBJECTIVE_TRACKING_PROB_REACH_OBJECTIVE:
        'probabilidad alcanzar objetivo',
    PROC_RA_OBJECTIVE_TRACKING_TOTAL_REFUND: 'Reembolso total',
    PROC_RA_OBJECTIVE_TRACKING_ACCOUNT_DETAILS: 'Detalle de la cuenta',
    PROC_RA_OBJECTIVE_TRACKING_DISSOCIATE_OBJECTIVE: 'Desvincular objetivo',
    PROC_RA_OBJECTIVE_DETAILS_AMOUNT_MODAL: 'modal modificar importe objetivo',
    PROC_RA_OBJECTIVE_TRACKING_MANAGE_CONTRIBUTIONS: 'Gestionar aportaciones',
    PROC_RA_OPTIONS_MENU: 'menu opciones',
    PROC_RA_ORDERS_AND_MOVEMENTS: 'ordenes y movimientos',
    PROC_RA_PORTFOLIO_TRACKING: 'robo-advisor/portfolio-tracking',
    PROC_RA_PORTFOLIO_TRACKING_INTERACTION: 'interaccion portfolio tracking',
    PROC_RA_PORTFOLIO_TRACKING_ASSOCIATE_OBJECTIVE: 'asociar objetivo',
    PROC_RA_PORTFOLIO_TRACKING_ACCOUNT_DETAILS: 'detalle de la cuenta',
    PROC_RA_PORTFOLIO_TRACKING_CANCEL_PORTFOLIO: 'cancelar cartera',
    PROC_RA_PORTFOLIO_TRACKING_MODIFY_STRATEGY: 'modificar estrategia',
    PROC_RA_PORTFOLIO_TRACKING_REFUND: 'solicitar reembolso',
    PROC_RA_PORTFOLIO_EVOLUTION_CARD: 'card evolucion',
    PROC_RA_PORTFOLIO_EVOLUTION_TEXT:
        '¿Por qué aún no ves evolución en el gráfico?',
    PROC_RA_PORTFOLIO_TRACKING_EXPECTED_PROFITABILITY: 'proyección futuro',
    PROC_RA_REFUND_CANCELLED: 'cancelar',
    PROC_RA_REFUND_START: 'inicio',
    PROC_RA_REFUND_SUCCESS: 'exito',
    PROC_RA_REFUND_WALLET: 'robo cartera ',
    PROC_RA_TRACKING_ORDERS_MOVEMENTS: 'Ordenes y movimientos',
    PROC_RA_TRACKING_SUITABILITY_TEST: 'Test idoneidad',
    PROC_RA_START: 'inicio',
    PROC_RA_SUCCESS: 'exito',
    PROC_RA_SUITABILITY_TEST_CHECK_STATUS: 'consultar test',
    PROC_RA_SUITABILITY_TEST_MODIFY_STATUS: 'modificar test',
    PROC_RA_SUITABILITY_TEST_INTERACTION: 'interaccion en test de idoneidad',
    PROC_RA_SUITABILITY_TEST_PROCCESS: 'proc-robo-advisor-test-mifid',
    PROC_RA_SUITABILITY_PAGE_NAME: 'robo-advisor/test-mifid',
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1:
        'modal profesional de las finanzas',
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_STATUS:
        'proc-tu-inviertes-test-mifid',
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_CLOSE: 'entendido',
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_OPEN: 'vista',
    PROC_RA_SUITABILITY_TEST_ACCESS_MODAL: 'modal test idoneidad retomar',
    PROC_RA_SUITABILITY_TEST_RETRY_MODAL: 'modal test idoneidad retomar motivo',
    PROC_RA_SUITABILITY_TEST_VIEW: 'vista',
    PROC_RA_SUITABILITY_TEST_HANDLE_CLOSE: 'cerrar',
    PROC_RA_SUITABILITY_TEST_NEW_TEST: 'nuevo test',
    PROC_RA_SUITABILITY_TEST_RETRY_TEST: 'retomar test',
    PROC_RA_SUITABILITY_TEST_BEGIN_TEST: 'comenzar test',
    PROC_RA_SUITABILITY_TEST_STATUS: 'robo-advisor/resultado-test',
    PROC_RA_YEARS: ' años',
    RA_DATEPICKER_MAXIMUM_YEARS: '25',
    RA_ADDITIONAL_CONTRIBUTION_URL: '/myprofile/robo/additionalContribution',
    RA_ASSOCIATE_OBJECTIVE_URL: '/myprofile/robo/associateObjective',
    RA_DISSOCIATE_OBJECTIVE_URL: '/myprofile/robo/dissociateObjective',
    RAINCOMINGS: 'incomings',
    RAOUTGOINGS: 'outgoings',
    RA_MOVEMENTS_FILTER_ALL: 'TODOS',
    RAINITIAL_CONTRIBUTION_MIN: 10,
    RAINITIAL_CONTRIBUTION_MAX: 99999999.99,
    RAINITIAL_CONTRIBUTION_MIN_LABEL: '10',
    RAINITIAL_CONTRIBUTION_MAX_LABEL: '99999999.99',
    RA_CANCEL_PLAN_URL: '/myprofile/robo/cancelPlan',
    RA_CIRCULAR_GOAL_ICON_SUCCESS: 'success',
    RA_CIRCULAR_GOAL_ICON_WARNING: 'warning',
    RA_DISASSOCIATE_GOAL_URL: '/myprofile/robo/dissociateObjective',
    RA_FUND_TRANSFER_STEP1: 0,
    RA_FUND_TRANSFER_STEP2: 1,
    RA_FUND_TRANSFER_STEP3: 2,
    RA_FUND_TRANSFER_TOTAL_STEPS: 3,
    RA_PORTFOLIO_FUND_HIRING_METHOD: 'TRANSFER',
    RA_GOAL_REACHED: 'goalReached',
    RA_GOAL_NOT_REACHED: 'goalNotReached',
    RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE: 'informative',
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS: 'success',
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING: 'warning',
    RA_GOAL_NOTIFICATION_MODIFIER_IMPORTANT: 'important',
    RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE: 156,
    RA_INVESTMENT_HORIZON_INPUT_MAX: 99,
    RA_INVESTMENT_HORIZON_INPUT_MIN: 1,
    RA_INVESTMENT_HORIZON_MAX_MONTHS: 11,
    RA_INVESTMENT_HORIZON_MIN_MONTHS: 3,
    RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE: 25,
    RA_INVESTMENT_HORIZON_SLIDER_MAX: 26,
    RA_INVESTMENT_HORIZON_SLIDER_MIN: 1,
    RA_INVESTMENT_TYPE_FOUNDS: 'founds',
    RA_INVESTMENT_TYPE_MONEY: 'money',
    RA_INVEST_SLIDER_KEY1: 'investSlider-highConservative',
    RA_INVEST_SLIDER_KEY2: 'investSlider-conservative',
    RA_INVEST_SLIDER_KEY3: 'investSlider-moderated',
    RA_INVEST_SLIDER_KEY4: 'investSlider-dynamic',
    RA_INVEST_SLIDER_KEY5: 'investSlider-agressive',
    RA_INVEST_SLIDER_MIN: 1,
    RA_INVEST_SLIDER_MAX: 5,
    RA_MAX_INVESTMENT_PROFILE: 5,
    RA_LESS_THAN_PERCENT_VALUE: 1,
    RA_MANAGEMENT_CONTRIBUTION_URL:
        '/myprofile/robo/cancelPeriodicContributions',
    RA_ACCOUNT_DETAILS_URL: '/myprofile/robo/getAccountDetails',
    RA_SIMULATION_SCROLL_BUFFER: '225',
    RA_MODIFY_PLAN_URL: '/myprofile/robo/modifyPlan',
    RA_NO_STRATEGY_SELECTED: '',
    RA_OBJECTIVE_NOTIFICATION_NO_PRODUCTS: 0,
    RA_OBJECTIVE_NOTIFICATION_MIN: 1,
    RA_PROJECTION_CHART_ALL_PRODUCTS: 0,
    RA_PROJECTION_CHART_UP_KEY: 'up',
    RA_PROJECTION_CHART_MID_KEY: 'mid',
    RA_PROJECTION_CHART_LOW_KEY: 'low',
    RA_REFUND_REQUEST_MIN: 10,
    RA_REFUND_REQUEST_MAX: 31850,
    RA_REFUND_REQUEST_MIN_LABEL: '10',
    RA_REFUND_REQUEST_MAX_LABEL: '31850',
    RA_REFUND_REQUEST_URL: '/myprofile/robo/refundRequest',
    RA_REIMBURSEMENT_URL: '/myprofile/robo/reimbursement',
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT: 99999999,
    RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT: 500,
    RA_SUITABILITY_TEST_HEAD_OPERATION: 'raSuitabilityTest-raSuitabilityTest_',
    RA_SUITABILITY_TEST_HIRE_OPERATION: 'hire',
    RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION: 'modifyGoal',
    RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION: 'modify',
    RA_SUITABILITY_TEST_URL: '/myprofile/robo/test',
    RA_SUITABILITY_TEST_WIDGET: 'isFromTIWidget',
    RA_SUITABILITY_TEST_DISPLAY_LEAVE_MODAL: true,
    RA_SUITABILITY_TEST_STATUS: 'status',
    SECONDARY_BAR_COLOR: '#E3E9E9',
    SECURITY_BUY: 'SECURITY_BUY',
    SECURITY_SELL: 'SECURITY_SELL',
    STRATEGY_TRACKING_URL: '/myprofile/robo/portfolioTracking',
    STATUS_PENDING: 'PENDING',
    SUITABILITY_TEST: 'SUITABILITY_TEST',
    SUITABILITY_TEST_ALL_PRODUCTS: 0,
    SUITABILITY_TEST_HIGH_CONSERVATIVE: 1,
    SUITABILITY_TEST_CONSERVATIVE: 2,
    SUITABILITY_TEST_MODERATED: 3,
    SUITABILITY_TEST_DYNAMIC: 4,
    SUITABILITY_TEST_AGRESSIVE: 5,
    SUITABILITY_TEST_STEP_0: 'SUITABILITY_TEST_STEP_0',
    SUITABILITY_TEST_STEP_1: 'SUITABILITY_TEST_STEP_1',
    SUITABILITY_TEST_STEP_2: 'SUITABILITY_TEST_STEP_2',
    SUITABILITY_TEST_STEP_3: 'SUITABILITY_TEST_STEP_3',
    SUITABILITY_TEST_STEP_3_1: 'SUITABILITY_TEST_STEP_3_1',
    SUITABILITY_TEST_STEP_4: 'SUITABILITY_TEST_STEP_4',
    SUITABILITY_TEST_STEP_5: 'SUITABILITY_TEST_STEP_5',
    SUITABILITY_TEST_STEP_6: 'SUITABILITY_TEST_STEP_6',
    SUITABILITY_TEST_STEP_7: 'SUITABILITY_TEST_STEP_7',
    SUITABILITY_TEST_STEP_8: 'SUITABILITY_TEST_STEP_8',
    SUITABILITY_TEST_STEP_9: 'SUITABILITY_TEST_STEP_9',
    SUITABILITY_TEST_STEP_10: 'SUITABILITY_TEST_STEP_10',
    SUITABILITY_TEST_STEP_11: 'SUITABILITY_TEST_STEP_11',
    SUITABILITY_TEST_STEP_12: 'SUITABILITY_TEST_STEP_12',
    SUITABILITY_TEST_CATEGORY_1: 'SUITABILITY_TEST_CATEGORY_1',
    SUITABILITY_TEST_CATEGORY_2: 'SUITABILITY_TEST_CATEGORY_2',
    SUITABILITY_TEST_CATEGORY_3: 'SUITABILITY_TEST_CATEGORY_3',
    STEP_NUMBER_10: 10,
    STEP_NUMBER_11: 11,
    STEP_NUMBER_12: 12,
    STEP_NUMBER_13: 13,
    SUITABILITY_TEST_TOTAL_ANSWERS_TO_VALIDATE: 3,
    QUESTIONS_FOR_STEP: {
        SUITABILITY_TEST_STEP_3: ['103', '104'],
    },
    SUITABILITY_TEST_MODAL_QUESTION_500: 'SUITABILITY_TEST_MODAL_QUESTION_500',
    SUITABILITY_TEST_ACCORDION_QUESTION: [
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
    ],
    QUESTION_TO_FILTER_ON_1A_CASES: [
        '102',
        '103',
        '104',
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
        '112',
        '113',
        '114',
        '115',
    ],
    SUITABILITY_TEST_NO_TEST: 1,
    SUITABILITY_TEST_EXPIRED: 3,
    SUITABILITY_TEST_IN_PROGRESS: 5,
    SUITABILITY_TEST_UNSIGNED: 4,
    SUITABILITY_TEST_VALID: 2,
    SUITABILITY_TEST_REDO: 6,
    SUITABILITY_TEST_URL: '/myprofile/robo/test',
    SUITABILITY_TEST_URL_READ_ONLY: '/myprofile/robo/test/readOnly',
    SUITABILITY_TEST_STATUS_URL: '/myprofile/robo/testStatus',
    SUSTAINABILITY_ANSWER_NEUTRAL: 'neutral',
    SUSTAINABILITY_ANSWER_INTERMEDIATE: 'intermediate',
    SUSTAINABILITY_ANSWER_ADVANCED: 'advanced',
    SUSTAINABILITY_ANSWER_ARRAY: {
        answer1: 'neutral',
        answer2: 'intermediate',
        answer3: 'advanced',
    },
    SUMMARY_WIDGET_PAGE_SIZE: 3,
    SUMMARY_WIDGET_SAVE_SIMULATION: 1,
    TIME_HORIZON_CHECK_ERROR: 'TIME_HORIZON_CHECK_ERROR',
    TIME_HORIZON_CHECK_NOT_PERFORMED: 'TIME_HORIZON_CHECK_NOT_PERFORMED',
    TIME_HORIZON_CHECK_VALID: 'TIME_HORIZON_CHECK_VALID',
    TIME_HORIZON_CHECK_WARNING: 'TIME_HORIZON_CHECK_WARNING',
    TAX: 'TAX',
    TRANSFER_IN: 'TRANSFER_IN',
    TRANSFER_OUT: 'TRANSFER_OUT',
    VALID_ACCOUNT_SUBTYPES: [
        '800',
        '801',
        '803',
        '805',
        '807',
        '812',
        '813',
        '814',
        '819',
        '004',
        '005',
        '006',
        '007',
        '008',
        '010',
        '011',
        '015',
        '013',
        '014',
        '016',
        '017',
        '018',
        '019',
    ],
    VALID_ACCOUNT_TYPE: '300',
    VALID_ACCOUNT_TYPES: ['300', '301'],
    WITHDRAWAL: 'WITHDRAWAL',
    WIZARD_POSITION_FIRST: 'first',
    WIZARD_POSITION_MIDDLE: 'middle',
    WIZARD_POSITION_LAST: 'last',
    WIZARD_POSITION_SINGLE: 'single',
    RA_CONTRACT_PDF_HEIGHT: 165,
    RA_COVER_FONT: '34px MarkOT',
    RA_HISTORY_MODAL_ONE_PORTFOLIO: '1',
    RA_POTFOLIO_COMPOSITION_TABLE_DECIMAL_LENGTH: 2,
    RA_PORTFOLIO_WITH_RISK_LEVEL_1: 'Kuala Lumpur',
    RA_PORTFOLIO_WITH_RISK_LEVEL_2: 'Shanghai',
    RA_PORTFOLIO_WITH_RISK_LEVEL_3: 'Taipei',
    RA_PORTFOLIO_WITH_RISK_LEVEL_4: 'New York',
    RA_PORTFOLIO_WITH_RISK_LEVEL_5: 'Dubai',
    RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER: '+34 91 177 33 16',
    RA_MODAL_TYPE_1: 1,
    RA_MODAL_TYPE_2: 2,
    RA_MODAL_TYPE_3: 3,
    RA_MODAL_TYPE_5: 5,
    RA_MODAL_TYPE_6: 6,
    RA_DOCUMENT_URL: '/myprofile/documentation',
    RA_SAVE_SIMULATION_PORTFOLIO_ERROR_ID: '6',
    RA_SPANISH_RESIDENT: 'ES',
    RA_CUSTOM_PLAN_OBJ_VIEW: 'ra-custom-plan-by-objective-view',
    RA_MANAGEMENT_PLAN_VIEW: 'ra-management-plan-view',
    RA_OK_COVER: 'ra-ok-cover',
    ZINDEX_DEFAULT_VAL: 'auto',
    ZINDEX_DEF_OVERLAP_VAL: '10',
    RA_RETAKE_TEST_DEFAULT: 0,
    RA_RETAKE_TEST_NO_RETRIES: 1,
    RA_RETAKE_TEST_RETRIES_AVAILABLE: 2,
    RA_RETAKE_TEST_RETRIES_LIMIT: 3,
    RA_WIZARD_FIRST_STEP: 0,
    RA_WIZARD_SECOND_STEP: 1,
    RA_WIZARD_THIRD_STEP: 2,
    RA_WIZARD_FIFTH_STEP: 4,
    RA_WIZARD_SIXTH_STEP: 5,
    RA_WIZARD_SEVENTH_STEP: 6,
    RA_WIZARD_EIGHTH_STEP: 7,
    RA_WIZARD_NINETH_STEP: 8,
    RA_WIZARD_TENTH_STEP: 9,
    RA_WIZARD_ELEVENTH_STEP: 10,
};
